export default {"src":"/_next/static/media/roadmap-cross.2076a43d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};